import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { styled } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';

const DEBOUNCE_TIME = 1_000;

const StyTextField = styled(TextField)(({ theme }) => ({
    width: '100%',
    '& .MuiInputBase-root': {
        borderRadius: theme.spacing(3),
        paddingRight: '0px',
    },
}));

const SearchFieldAdornedInput = (
    search: string,
    handleClear: () => void,
): TextFieldProps['InputProps'] => {
    const startAdornment = (
        <InputAdornment position="start" sx={{ ml: 1 }}>
            <SearchIcon />
        </InputAdornment>
    );
    const endAdornment = (
        <IconButton onClick={handleClear} size="small" sx={{ mr: 1 }}>
            <ClearIcon />
        </IconButton>
    );
    return { startAdornment, ...(search ? { endAdornment } : {}) };
};

type TitleSearchProps = {
    search: string;
    setSearch: (arg: string) => void;
};

const TitleSearch = ({ search, setSearch }: TitleSearchProps): JSX.Element => {
    const { t } = useTranslation();
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        const timer = setTimeout(() => {
            setSearch(searchText); // Update parent search state after DEBOUNCE_TIME ms of inactivity
        }, DEBOUNCE_TIME);

        // Cleanup function to clear timer
        return () => clearTimeout(timer);
    }, [searchText, setSearch]);

    const handleClearSearch = () => {
        setSearch('');
        setSearchText('');
    };

    return (
        <StyTextField
            className="pendo-indicators-library-title-filter"
            onChange={(e) => setSearchText(e.target.value)}
            placeholder={
                search ? undefined : t('indicators.filterType.nameSearch')
            }
            label={search ? t('indicators.filterType.nameSearch') : undefined}
            size="small"
            value={searchText}
            variant="outlined"
            InputProps={SearchFieldAdornedInput(search, handleClearSearch)}
        />
    );
};

export default TitleSearch;
